import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
}

export const SearchIcon: React.FC<IconProps> = ({
  color = '#fff',
  size = 28,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    className={className}
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7 19.343l3.862 3.861a1.667 1.667 0 11-2.357 2.357L19.343 21.7a10.95 10.95 0 01-6.509 2.133c-6.072 0-11-4.927-11-11 0-6.072 4.928-11 11-11s11 4.928 11 11a10.95 10.95 0 01-2.134 6.51zm-3.36-1.173a7.64 7.64 0 002.16-5.337 7.664 7.664 0 00-7.666-7.666 7.664 7.664 0 00-7.667 7.666 7.664 7.664 0 007.667 7.667 7.64 7.64 0 005.336-2.16l.17-.17z"
      fill={color}
      opacity={color ? 1 : 0.4}
    />
  </svg>
)
